import { SearchType } from 'app2/api';
import { useUserPreference } from 'app2/views/shared-public';

export function useSearchTypePreference() {
  return useUserPreference('searchType', SearchType.Student);
}
